export function getApiLogReadReactPath(logId: string | number): string {
  return `/reports/api-logs/${encodeURIComponent(String(logId))}`
}

/** Href for API log detail (application-details Failed Payment Attempts). */
export function getApiLogReadUrl(logId: string | number): string {
  return getApiLogReadReactPath(logId)
}

export function openApiLogReadInNewTab(logId: string | number): void {
  window.open(getApiLogReadReactPath(logId), '_blank', 'noopener,noreferrer')
}

export function getMailgunLogReadReactPath(logId: string | number): string {
  return `/reports/mailgun-logs/read/${encodeURIComponent(String(logId))}`
}

/** Href for mailgun log detail (application-details Email History). */
export function getMailgunLogReadUrl(logId: string | number): string {
  return getMailgunLogReadReactPath(logId)
}

export function openMailgunLogReadInNewTab(logId: string | number): void {
  window.open(getMailgunLogReadReactPath(logId), '_blank', 'noopener,noreferrer')
}

/** Company/property Payments → Default payment history. */
export function getDefaultPaymentLogsReactPath(): string {
  return '/reports/default-payment-logs'
}

export function getDefaultPaymentLogDetailReactPath(paymentLogId: string | number): string {
  return `/reports/default-payment-logs/${encodeURIComponent(String(paymentLogId))}`
}

export function getDefaultPaymentLogDetailUrl(paymentLogId: string | number): string {
  return getDefaultPaymentLogDetailReactPath(paymentLogId)
}

/** Default payment log Transaction Details (same tab as the Angular `routerLink`). */
export function openDefaultPaymentLogDetail(paymentLogId: string | number): void {
  window.location.assign(getDefaultPaymentLogDetailReactPath(paymentLogId))
}

/**
 * Open Default Payment Logs in a new tab.
 * Caller should seed `defaultpaymentlogs_filter` in sessionStorage first (same as Angular).
 */
export function openDefaultPaymentLogsInNewTab(): void {
  window.open(getDefaultPaymentLogsReactPath(), '_blank', 'noopener,noreferrer')
}
